<template>
  <v-app>
    <v-toolbar fixed
               color="white">
      <v-toolbar-title>
        <v-btn flat>
          <img src="static/img/logo.png"
               height="40">
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat
               @click="scrollTo('.contact')"
               class="hidden-sm-and-down">
          {{ $t('home_navbar_add_parking') }}
        </v-btn>
        <v-btn flat
               @click="pushRoute('Login')"
               class="hidden-sm-and-down">
          {{ $t('home_navbar_login') }}
        </v-btn>
      </v-toolbar-items>

      <v-avatar class="primary hidden-md-and-up mr-3"
                @click="scrollTo('.contact')"
                size=30>
        <v-icon dark>local_parking</v-icon>
      </v-avatar>

      <v-avatar class="primary hidden-md-and-up mr-3"
                size=30
                @click="pushRoute('Login')">
        <v-icon dark>fa fa-sign-in</v-icon>
      </v-avatar>

      <change-language-dropdown custom-class="dropup"></change-language-dropdown>
    </v-toolbar>

    <v-content>
      <video-bg :sources="['/static/city.mp4']"
                class="video-section">
        <div class="overlay"></div>

        <v-container fluid
                     fill-height>
          <v-layout align-center
                    justify-center>
            <v-flex xs10
                    sm8
                    md8
                    class="video-overlay">
              <h1 data-wow-delay="0.2s"
                  class="wow animated fadeInDown"
                  style="visibility: hidden"
                  v-html="$t('home_slogan_big')"></h1>

              <p class="wow animated fadeInDown"
                 data-wow-delay="0.3s"
                 style="visibility: hidden"
                 v-html="$t('home_slogan_small')"></p>
            </v-flex>
          </v-layout>
        </v-container>

        <v-footer absolute
                  class="awards-wrapper">
          <v-layout row
                    wrap
                    justify-end>
            <h2 v-html="$t('home_winners')"></h2>

            <v-tooltip top>
              <span> {{ $t('home_awards_tooltip.internetDay') }} </span>
              <a href="https://www.efeempresas.com/noticia/campana-25-000-billetes-25-euros-renfe-recibe-el-premio-de-internet-en-la-categoria-de-publicidad-online/"
                 target="_blank"
                 slot="activator"
                 class="pulse animated"
                 style="animation-duration: 2s; animation-delay: 300ms; animation-iteration-count: infinite;">
                <img src="static/img/awards/premios_diadeinternet.png"
                     height="50px"
                     class="ml-3" />
              </a>
            </v-tooltip>

            <v-tooltip top>
              <span> {{ $t('home_awards_tooltip.wsa') }} </span>

              <a href="https://www.worldsummitawards.org/winner/wesmartpark/"
                 target="_blank"
                 slot="activator"
                 class="pulse animated"
                 style="animation-duration: 2s; animation-delay: 300ms; animation-iteration-count: infinite;">
                <img src="static/img/awards/wsa_premio.png"
                     height="50px"
                     class="ml-3" />
              </a>
            </v-tooltip>

            <v-tooltip top>
              <span> {{ $t('home_awards_tooltip.4yfn') }} </span>
              <a href="https://mobileworldcapital.com/es/press/los-4yfn-awards-premian-wesmartpark-como-la-startup-mas-innovadora-en-el-ambito-de-las-ciudades-inteligentes/"
                 target="_blank"
                 slot="activator"
                 class="pulse animated"
                 style="animation-duration: 2s; animation-delay: 300ms; animation-iteration-count: infinite;">
                <img src="static/img/awards/premios_4yfn.png"
                     height="50px"
                     class="mr-3 ml-3" />
              </a>
            </v-tooltip>
          </v-layout>
        </v-footer>
      </video-bg>

      <v-container grid-list-md>

        <span class="section"></span>
        <h2 v-html="$t('home_section1_title')"></h2>
        <v-layout row
                  wrap>
          <v-flex xs12
                  sm4>
            <v-card height="100%"
                    class="mb-3"
                    flat>
              <v-card-text class="background-color-primary pa-0">
                <h3 class="headline white--text">
                  <v-icon color="white"
                          size="30">attach_money</v-icon>
                  {{ $t('home_section1_group1_title') }}
                </h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group1_element1') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group1_element2') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group1_element3') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group1_element4') }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12
                  sm4>
            <v-card height="100%"
                    class="mb-3"
                    flat>
              <v-card-text class="background-color-primary pa-0">
                <h3 class="headline white--text">
                  <v-icon color="white"
                          size="30">lock_outline</v-icon>
                  {{ $t('home_section1_group2_title') }}
                </h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group2_element1') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group2_element2') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group2_element3') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group2_element4') }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12
                  sm4>
            <v-card height="100%"
                    flat>
              <v-card-text class="background-color-primary pa-0">
                <h3 class="headline white--text">
                  <v-icon color="white"
                          size="30">schedule</v-icon>
                  {{ $t('home_section1_group3_title') }}
                </h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group3_element1') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group3_element2') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group3_element3') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section1_group3_element4') }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="numbers">
        <v-container grid-list-md
                     pt-3
                     pb-3>
          <h2 class="white--text">
            {{ $t('home_section2_title') }}
          </h2>

          <v-layout row
                    wrap
                    justify-center>
            <v-flex xs8
                    md2>
              <v-card height="100%"
                      color="transparent"
                      class="white--text"
                      flat>
                <v-card-text class="pa-0">
                  <v-icon color="white"
                          medium>ti-location-pin</v-icon>
                  <counter-up value="150"
                              step="1"
                              class="ml-2 white--text d-inline" />
                </v-card-text>
                <v-card-title primary-title>
                  {{ $t('home_section2_element1') }}
                </v-card-title>
              </v-card>
            </v-flex>

            <v-flex xs8
                    md2>
              <v-card height="100%"
                      color="transparent"
                      class="white--text"
                      flat>
                <v-card-text class="pa-0">
                  <v-icon color="white"
                          medium>ti-face-smile</v-icon>
                  <counter-up value="100000"
                              step="560"
                              class="ml-2 white--text d-inline" />
                </v-card-text>
                <v-card-title primary-title>
                  {{ $t('home_section2_element2') }}
                </v-card-title>
              </v-card>
            </v-flex>

            <v-flex xs8
                    md2>
              <v-card height="100%"
                      color="transparent"
                      class="white--text"
                      flat>
                <v-card-text class="pa-0">
                  <v-icon color="white"
                          medium>ti-stats-up</v-icon>
                  <counter-up value="400"
                              suffix='%'
                              step="1"
                              class="ml-2 white--text d-inline" />
                </v-card-text>
                <v-card-title primary-title>
                  {{ $t('home_section2_element3') }}
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <v-container grid-list-md>
        <span class="section"></span>
        <h2>{{ $t('home_section3_title') }}</h2>

        <v-layout row
                  wrap>

          <v-flex xs12
                  sm4
                  class="solution-list">
            <v-card height="100%"
                    class="mb-3"
                    flat>
              <v-card-text class="pa-0">
                <h3 class="headline primary--text">
                  {{ $t('home_pricing_owners_title') }}</h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_pricing_owners_dot1')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_pricing_owners_dot2')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_pricing_owners_dot3')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_pricing_owners_dot4')}}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12
                  sm4
                  class="numbers-section">
            <v-card height="100%"
                    class="mb-3"
                    flat>
              <v-card-text class="pa-0">
                <h3 class="headline primary--text">
                  {{ $t('home_pricing_corp_title') }}
                </h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section4_group2_element1') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section4_group2_element2') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section4_group2_element3') }}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{ $t('home_section4_group2_element4') }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12
                  sm4
                  class="numbers-section">
            <v-card height="100%"
                    flat>
              <v-card-text class="pa-0">
                <h3 class="headline primary--text">
                  {{ $t('home_pricing_realstate_title') }}</h3>
              </v-card-text>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_section4_group3_element1')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_section4_group3_element2')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_section4_group3_element3')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_pricing_realstate_dot2')}}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="grey lighten-5">
        <v-container grid-list-md
                     class="pb-4">
          <span class="section mt-5"></span>
          <h2>{{$t('home_section5_title')}}</h2>
          <v-layout row
                    wrap
                    justify-center>
            <template v-for="partner in partners">
              <v-flex xs12
                      md1
                      class="text-center"
                      :key="partner.name">
                <v-card class="grey lighten-4">
                  <v-card-text class="title pa-3">
                    <img :src="`static/img/partners/${partner.logo}`"
                         height="60px"
                         class="mt-2">
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </div>

      <div class="contact white--text">
        <v-container grid-list-md>
          <v-layout row
                    wrap>
            <v-flex sm10
                    offset-md1
                    text-center>
              <h1 class="white--text">
                {{$t('home_section6_title')}}
              </h1>
              <p class="subtitle white--text">
                {{$t('home_section6_subtitle')}}
              </p>
              <v-btn color="primary"
                     @click="trackEvent('footerContactar')"
                     target="_blank"
                     block
                     :href="$t('url_contact_typeform')">
                <b>{{$t('home_section6_button')}}</b>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <span class="section secure-section"></span>
      <h2>{{$t('home_section7_title')}}</h2>

      <v-container grid-list-md
                   class="mb-5">
        <v-layout row
                  wrap>
          <v-flex xs12
                  sm6>
            <div>
              <img :src="$t('img_parking_squema')"
                   width="90%" />
            </div>
          </v-flex>

          <v-flex xs12
                  sm6
                  class="secure-list">
            <v-card height="100%"
                    flat>
              <v-card-title primary-title>
                <v-list dense>
                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('solution_about_dots1')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('solution_about_dots2')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('solution_about_dots3')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('solution_about_dots4')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('solution_about_dots5')}}
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar
                               class="dps-dense">
                    <v-list-tile-action>
                      <v-icon color="primary">fa-dot-circle-o</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      {{$t('home_section7_element6')}}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid
                   class="access-section">
        <div class="img-parking-door"></div>
        <div class="overlay"></div>
        <v-layout flex>
          <div class="access-section-text wow animated fadeInRight">
            <h2 class="white--text"
                v-html="$t('solution_access_title')"></h2>
            <v-list two-line
                    class="trasparent-background white--text">
              <v-list-tile avatar>
                <v-list-tile-avatar color="primary">
                  <v-icon color="white">fa fa-car</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content color="white">
                  <v-list-tile-title v-html="$t('solution_access_car_title')"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t('solution_access_car_description')"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile avatar>
                <v-list-tile-avatar color="primary">
                  <v-icon color="white">fa fa-car</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content color="white">
                  <v-list-tile-title v-html="$t('solution_access_walk_title')"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t('solution_access_walk_description')"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </v-layout>
      </v-container>

      <v-container>
        <span class="section"></span>
        <h2>{{$t('home_section9_title')}}</h2>

        <section id="about">
          <v-container fluid
                       grid-list-md>
            <v-container grid-list-md>
              <v-layout row
                        wrap>
                <v-flex xs12
                        sm6
                        class="solution-list">
                  <div>
                    <div class="wow animated fadeInUp">
                      <div>
                        <h4 v-html="$t('solution_tools_stats_title')"></h4>
                        <p v-html="$t('solution_tools_stats_description')"></p>
                      </div>
                    </div>
                    <div class="wow animated fadeInUp">
                      <div>
                        <h4 v-html="$t('solution_tools_tenants_title')"></h4>
                        <p>{{$t('home_section9_element2')}}</p>
                      </div>
                    </div>
                    <div class="wow animated fadeInUp">
                      <div>
                        <h4 v-html="$t('solution_tools_alerts_title')"></h4>
                        <p>{{$t('home_section9_element3')}}</p>
                      </div>
                    </div>
                    <div class="wow animated fadeInUp">
                      <div>
                        <h4 v-html="$t('solution_tools_reports_title')"></h4>
                        <p>{{$t('home_section9_element4')}}</p>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12
                        sm6>
                  <img src="static/img/pms-dash.png"
                       width="90%" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </section>
      </v-container>

      <div class="contact-bis white--text">
        <v-btn color="primary"
               @click="trackEvent('footerContactar')"
               target="_blank"
               block
               :href="$t('url_contact_typeform')">
          <b>{{$t('home_section10_button')}}</b>
        </v-btn>
      </div>

      <v-container grid-list-md
                   class="pb-4">
        <span class="section mt-5"></span>
        <h2>{{$t('home_section11_title')}}</h2>
        <v-layout row
                  wrap
                  justify-center>
          <template v-for="investor in investors">
            <v-flex xs3
                    sm2
                    class="text-center"
                    :key="investor.name">
              <img :src="`static/img/investors/${investor.logo}`"
                   height="60px"
                   class="mt-2" />
              <div class="name mb-2">{{ investor.name }}</div>
            </v-flex>
          </template>
        </v-layout>

      </v-container>
    </v-content>

    <dps-footer :expanded-footer=expandedFooter></dps-footer>
  </v-app>
</template>
<script>
import VideoBg from 'vue-videobg';
import Wow from 'wowjs';
import CounterUp from '@/components/commons/CounterUp.vue';
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown.vue';
import DpsFooter from '@/components/commons/Footer';
import store from '@/store';

export default {
  name: 'home',

  components: {
    'video-bg': VideoBg,
    [CounterUp.name]: CounterUp,
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown,
    [DpsFooter.name]: DpsFooter
  },

  beforeRouteEnter(to, from, next) {
    if (store.state.isLogged) {
      next('/dashboard');
      return;
    }
    next();
  },

  data() {
    return {
      investors: store.state.investorsLinks,
      partners: store.state.partnersLinks,
      expandedFooter: true
    };
  },

  mounted() {
    let wow = new Wow.WOW({
      boxClass: 'wow', // animated element css class (default is wow)
      animateClass: 'animated', // animation css class (default is animated)
      offset: 100, // distance to the element when triggering the animation (default is 0)
      mobile: false // trigger animations on mobile devices (true is default)
    });
    wow.init();
  },

  methods: {
    pushRoute(name) {
      this.$router.push({ name: name });
    },
    scrollTo(section, eventNameTracked) {
      let options = {
        container: 'body',
        easing: 'ease-in',
        offset: -64,
        cancelable: true,
        onDone: function() {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      };
      this.$scrollTo(section, 750, options);
    },
    trackEvent(event) {
      this.$ga.event({
        eventCategory: 'link',
        eventAction: 'click',
        eventLabel: event
      });
    }
  }
};
</script>


<style lang="scss" scoped>
@import '~@/assets/sass/dps-home.scss';
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue